module.exports = __webpack_public_path__ + "static/media/signup-web.db6fb8a9.png";